import { redirect } from 'next/navigation';
import { getAuthToken } from './getToken';

export async function mutateData(
  method: string,
  url: string,
  payload?: any,
  headers?: any
) {
  const authToken = await getAuthToken();

  if (!authToken) throw new Error('No auth token found');
  try {
    const response = await fetch(url, {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${JSON.parse(authToken || '')?.token ?? ''}`,
        ...headers,
      },
      body: JSON.stringify({ ...payload }),
    });
    if (!response.ok) {
      // Try to parse the error message from the response body
      const errorData = await response.json().catch(() => null);

      if (errorData?.error === 'Access Denied') {
        redirect('/403');
      }
      const errorMessage =
        errorData?.error || `Error: ${response.statusText || response.status}`;
      return { ok: false, data: null, error: errorMessage };
    }

    if (method === 'DELETE') {
      return { message: 'Deleted' };
    }
    if (response.status === 403) {
      redirect('/403');
    }
    try {
      const data = await response.json();
      return data;
    } catch (error) {
      // If response.json() fails, return true
      return {
        data: true,
      };
    }
  } catch (error) {
    throw { error };
  }
}

export async function uploadFile(
  method: string,
  url: string,
  formData: FormData
) {
  const authToken = await getAuthToken();

  if (!authToken) throw new Error('No auth token found');

  try {
    const response = await fetch(url, {
      method: method,
      headers: {
        Authorization: `Bearer ${JSON.parse(authToken || '')?.token ?? ''}`,
      },
      body: formData,
    });
    if (method === 'DELETE') {
      return { message: 'Deleted' };
    }
    if (!response.ok) {
      const errorData = await response.json().catch(() => null);

      return { error: errorData.error };
    }
    if (response.status === 403) {
      redirect('/403');
    }
    // if (response.status === 201) {
    //   return { message: 'Success' };
    // }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function testMutate(
  method: string,
  url: string,
  payload?: any,
  headers?: any
) {
  const authToken = await getAuthToken();

  if (!authToken) throw new Error('No auth token found');
  try {
    const response = await fetch(url, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${JSON.parse(authToken || '')?.token ?? ''}`,
      },
    });
    if (!response.ok) {
      // Try to parse the error message from the response body
      const errorData = await response.json().catch(() => null);

      if (errorData?.error === 'Access Denied') {
        redirect('/403');
      }
      const errorMessage =
        errorData?.error || `Error: ${response.statusText || response.status}`;
      return { ok: false, data: null, error: errorMessage };
    }

    if (method === 'DELETE') {
      return { message: 'Deleted' };
    }
    if (response.status === 403) {
      redirect('/403');
    }
    try {
      const data = await response.json();
      return data;
    } catch (error) {
      // If response.json() fails, return true
      return {
        data: true,
      };
    }
  } catch (error) {
    throw { error };
  }
}
